import { FC } from 'react'

import { Box, Flex, Heading, Image, Link, VStack } from '@chakra-ui/react'
import { useEditorChrome } from '@editor/EditorProvider'
import { Link as RouterLink } from 'react-router'

export const AppError: FC<{
  description: string
  image: string
}> = ({ description, image }) => {
  const { topNavbar } = useEditorChrome()

  return (
    <VStack w="100%" h="100%" gap={0}>
      {topNavbar}
      <Flex w="100%" h="100%" flex={1} justify="center" align="center">
        <Box>
          <Box>
            <Image src={image} alt={description} />
          </Box>
          <Box textAlign="center">
            <Heading fontSize="lg">{description}</Heading>
          </Box>
          <Box textAlign="center" mt={8}>
            <Link fontSize="sm" variant="underline" asChild href="/">
              <RouterLink to="/">トップへ</RouterLink>
            </Link>
          </Box>
        </Box>
      </Flex>
    </VStack>
  )
}
